<app-standard-table
  class="flex-1 flex flex-col min-h-0"
  [title]="'admin.ticketList'"
  [columns]="columnList"
  [data]="tableDataFilters"
  [totalItems]="totalItems"
  [pageSize]="pageSize"
  [isLoading]="isLoading"
  [currentPage]="currentPage"
  (searchChange)="search($event)"
  (sortChange)="onSort($event)"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
  (rowClick)="onClickRow($event)"
  (create)="openCreateModal()"
  (edit)="onEditTicket($event)"
  (delete)="onDeleteTicket($event)"
  [showDateFilter]="true"
  (dateFilterChange)="onDateFilterChange($event)"
  [showStatusFilter]="true"
  (statusFilterChange)="onStatusFilterChange($event)"
  [showAlphabetFilter]="true"
  [alphabetOptions]="['A-', 'B-', 'C-']"
  (alphabetFilterChange)="onAlphabetFilterChange($event)"
  [isImport]="true"
  (import)="importTickets($event)">
</app-standard-table>


<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ (isEditMode ? 'modal.editTicket' : 'modal.createTicket') | translate }}</h3>
      <button class="close-icon" (click)="closeModal()">&times;</button>
    </div>

    <div class="form-body">

      <div class="ticket-row-header">
        <span class="col-label">{{ 'modal.alphabet' | translate }}</span>
        <span class="col-label">{{ 'modal.ticketNumber' | translate }}</span>
        <span class="col-label-action"></span>
      </div>

      <ng-container *ngIf="isEditMode">
        <div class="ticket-row">
          <select [(ngModel)]="newTicket.alphabet" class="form-input">
            <option value="A-">A</option>
            <option value="B-">B</option>
            <option value="C-">C</option>
          </select>
          <input
            type="text"
            [(ngModel)]="newTicket.number"
            [placeholder]="'modal.ticketNumberPlaceholder' | translate"
            class="form-input"
          />
          <div class="row-action-placeholder"></div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isEditMode">
        <div class="ticket-row" *ngFor="let ticket of ticketRows; let i = index">
          <select [(ngModel)]="ticket.alphabet" class="form-input">
            <option value="A-">A</option>
            <option value="B-">B</option>
            <option value="C-">C</option>
          </select>
          <input
            type="text"
            [(ngModel)]="ticket.number"
            [placeholder]="'modal.ticketNumberPlaceholder' | translate"
            class="form-input"
          />
          <button
            type="button"
            class="btn-remove-row"
            (click)="removeTicketRow(i)"
            *ngIf="ticketRows.length > 1"
            title="Remove"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <div class="row-action-placeholder" *ngIf="ticketRows.length === 1"></div>
        </div>

        <button type="button" class="btn-add-row" (click)="addTicketRow()">
          <i class="fa-solid fa-plus"></i>
          {{ 'modal.addRow' | translate }}
        </button>
      </ng-container>

    </div>

    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="closeModal()" [disabled]="isSaving">
        {{ 'admin.cancel' | translate }}
      </button>
      <button type="button" class="btn-create" (click)="submitTicket()" [disabled]="isSaving || !isFormValid()">
        <span *ngIf="!isSaving">{{ (isEditMode ? 'modal.updateTicket' : 'modal.createTicketBtn') | translate }}</span>
        <span *ngIf="isSaving" class="flex items-center gap-2">
          <span class="spin-icon"></span>
          {{ 'modal.saving' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>